import { frontendURL } from '../../../helper/URLHelper';
import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';
import VisitorsIndex from './pages/Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/visitors'),
    name: 'visitors_dashboard_index',
    component: VisitorsIndex,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
